import React, { useState, useEffect } from 'react';
import './CookieSettings.css';

const CATEGORIES = [
  { key: 'essential', label: 'Esenciales (siempre activas)', disabled: true },
  { key: 'analytics', label: 'Analíticas' },
];

function CookieSettings() {
  const [prefs, setPrefs] = useState({ essential: true });

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('cookie-prefs')) || {};
    setPrefs({ essential: true, ...stored });
  }, []);

  const toggle = (key) => {
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    localStorage.setItem('cookie-prefs', JSON.stringify(next));

    if (!next.analytics) {
      document.cookie
        .split(';')
        .forEach((c) => {
          if (c.trim().startsWith('_ga') || c.trim().startsWith('_gid')) {
            document.cookie = c.replace(/=.*/, '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/');
          }
        });
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="settings-container">
      <h1>Configuración de cookies</h1>
      <p>Gestiona aquí tus preferencias:</p>
      <ul className="settings-list">
        {CATEGORIES.map((cat) => (
          <li key={cat.key}>
            <label>
              <input
                type="checkbox"
                checked={!!prefs[cat.key]}
                disabled={cat.disabled}
                onChange={() => toggle(cat.key)}
              />
              {cat.label}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default CookieSettings;
